import { render, staticRenderFns } from "./land-form.html?vue&type=template&id=1b5eaffe&scoped=true&external"
import script from "./land-form.js?vue&type=script&lang=js&external"
export * from "./land-form.js?vue&type=script&lang=js&external"
import style0 from "./land-form.scss?vue&type=style&index=0&id=1b5eaffe&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5eaffe",
  null
  
)

export default component.exports